import { render } from "./LaravelVueDatatablesCellHeader.vue?vue&type=template&id=379a481a"
import script from "./LaravelVueDatatablesCellHeader.vue?vue&type=script&lang=js"
export * from "./LaravelVueDatatablesCellHeader.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__